// import React, { useEffect, useState } from 'react';
// import { Modal, Container, Card, Row, Col, ListGroup, Badge, Spinner, Image, Table } from 'react-bootstrap';
// import { FaPhone, FaCopy, FaWhatsapp, FaEnvelope, FaProjectDiagram, FaUserAlt, FaCalendarAlt, FaClock, FaHistory } from 'react-icons/fa';
// import { Divider, Skeleton, useTheme, Avatar } from '@mui/material';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import * as XLSX from 'xlsx';
// import moment from 'moment';
// import { db_url } from '../Api/BaseUrl';
// import { useSelector, useDispatch } from 'react-redux';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';

// export const PreviewLeadModal = ({ show, onHide, lead, loading }) => {
//     const theme = useTheme();
//     const mode = theme.palette.mode;
//     const dispatch = useDispatch();
//     const [assignmentLoading, setAssignmentLoading] = useState(false);

//     // جلب البيانات من Redux store - من المكان الصحيح
//     const resleadassigned = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);
//     const LeadAssignedarray = Array.isArray(resleadassigned?.data) ? resleadassigned.data : [];

//     // جلب بيانات الـ assignments عندما يفتح الـ modal
//     useEffect(() => {
//         if (show && lead?.leadId) {
//             console.log('🚀 Fetching assignments for lead:', lead.leadId, lead.name);
//             const fetchAssignmentData = async () => {
//                 setAssignmentLoading(true);
//                 try {
//                     await dispatch(Get_All_Lead_Assigned_Data_Action(lead.leadId));
//                     console.log('✅ Assignment data fetched successfully');
//                 } catch (error) {
//                     console.error('❌ Error fetching assignment data:', error);
//                 }
//                 setAssignmentLoading(false);
//             };
//             fetchAssignmentData();
//         }
//     }, [show, lead?.leadId, dispatch]);

//     const getCleanImageUrl = (filename) => {
//         if (!filename) return null;
//         return `${db_url}/UsersImages/${filename}`;
//     };

//     const formatDateTime = (date) => {
//         if (!date) return '—';
//         return date.toLocaleString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };

//     const formatDuration = (ms) => {
//         if (isNaN(ms)) return '—';

//         const seconds = Math.floor(ms / 1000);
//         const minutes = Math.floor(seconds / 60);
//         const hours = Math.floor(minutes / 60);
//         const days = Math.floor(hours / 24);

//         return [
//             days > 0 ? `${days}d` : null,
//             hours % 24 > 0 ? `${hours % 24}h` : null,
//             minutes % 60 > 0 ? `${minutes % 60}m` : null,
//             seconds % 60 > 0 ? `${seconds % 60}s` : null
//         ].filter(Boolean).join(' ') || '0s';
//     };

//     // دالة لإنشاء أحرف مختصرة للأسماء
//     const getInitials = (name) => {
//         if (!name) return '?';
//         return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
//     };

//     // ألوان للـ Avatars
//     const avatarColors = [
//         '#2196f3', '#ff9800', '#4caf50', '#f44336', '#9c27b0',
//         '#00bcd4', '#ffeb3b', '#795548', '#607d8b', '#3f51b5'
//     ];

//     const getAvatarColor = (salesName) => {
//         let hash = 0;
//         for (let i = 0; i < salesName.length; i++) {
//             hash = salesName.charCodeAt(i) + ((hash << 5) - hash);
//         }
//         return avatarColors[Math.abs(hash) % avatarColors.length];
//     };

//     // دالة محسنة لتحويل بيانات التعيينات
//     const transformAssignmentData = () => {
//         console.log('=== 🔍 TRANSFORMING ASSIGNMENT DATA ===');
//         console.log('📊 LeadAssignedarray length:', LeadAssignedarray.length);
//         console.log('👤 Current lead:', lead);
//         console.log('🆔 Current lead ID:', lead?.leadId);
//         console.log('📛 Current lead Name:', lead?.name);

//         if (!Array.isArray(LeadAssignedarray) || LeadAssignedarray.length === 0 || !lead?.leadId) {
//             console.log('❌ No data to transform - returning empty array');
//             return [];
//         }

//         // تصفية الـ assignments للـ lead الحالي فقط
//         const currentLeadAssignments = LeadAssignedarray.filter(assignment => {
//             const assignmentLeadId = assignment.LeadId?._id || assignment.LeadId;
//             const isMatch = assignmentLeadId === lead.leadId;

//             console.log(`🔍 Checking assignment:`, {
//                 assignmentLeadId,
//                 currentLeadId: lead.leadId,
//                 isMatch
//             });

//             return isMatch;
//         });

//         console.log('✅ Filtered assignments for current lead:', currentLeadAssignments.length);

//         // ترتيب الـ assignments حسب التاريخ (الأحدث أولاً)
//         const sortedAssignments = currentLeadAssignments.sort((a, b) => {
//             const dateA = new Date(a.date_Assigned || a.createdAt);
//             const dateB = new Date(b.date_Assigned || b.createdAt);
//             return dateB - dateA;
//         });

//         // تحويل البيانات إلى التنسيق المطلوب للعرض
//         const assignmentsForDisplay = sortedAssignments.map((assignment, index) => {
//             const salesName = assignment.Assigned_to?.name || 'Unknown Sales';
//             const assignedFrom = assignment.Assigned_From?.name || 'Unknown';
//             const dateAssigned = assignment.assignDateTime || assignment.createdAt;

// let formattedDate = 'Unknown Date';
// if (dateAssigned) {
//     try {
//         console.log('🔍 RAW DATE:', dateAssigned); // شوف البيانات الأصلية

//         const date = new Date(dateAssigned);

//         // لو الوقت 00:00:00، يبقى مفيش وقت مخزون
//         if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
//             // اعرض التاريخ فقط بدون وقت
//             formattedDate = moment(dateAssigned).format('DD/MM/YYYY');
//         } else {
//             // اعرض التاريخ مع الوقت بنظام 12 ساعة مع AM/PM
//             formattedDate = moment(dateAssigned).format('DD/MM/YYYY hh:mm:ss A');
//         }

//     } catch (error) {
//         console.error('Error formatting date:', error);
//         formattedDate = 'Date Error';
//     }
// }

//             return {
//                 id: assignment._id || index,
//                 salesName: salesName,
//                 assignedFrom: assignedFrom,
//                 date: formattedDate,
//                 type: 'Assigned',
//                 originalData: assignment
//             };
//         });

//         console.log('🎯 Final assignments for display:', assignmentsForDisplay);
//         return assignmentsForDisplay;
//     };

//     const leadAssignmentHistory = transformAssignmentData();

//     // إحصائيات
//     const totalAssignments = leadAssignmentHistory.length;
//     const uniqueSales = new Set(leadAssignmentHistory.map(a => a.salesName)).size;

//     console.log('📈 Stats - Total:', totalAssignments, 'Unique:', uniqueSales);

//     // دالة التصدير لـ Excel (من الصفحة الأولى)
//     const flattenData = (data) => {
//         if (!Array.isArray(data)) {
//             console.error('Expected an array but received:', data);
//             return [];
//         }
//         return data.map((item) => ({
//             id: item._id || 'N/A',
//             Lead_Name: item.LeadId ? item.LeadId.name : 'N/A',
//             Assigned_From_User: item.Assigned_From ? item.Assigned_From.name : 'N/A',
//             Assigned_to_sales: item.Assigned_to ? item.Assigned_to.name : 'N/A',
//             date_Assigned: item.date_Assigned || 'N/A',
//         }));
//     };

//     const exportToExcel = () => {
//         const flattenedData = flattenData(LeadAssignedarray.filter(assignment => {
//             const assignmentLeadId = assignment.LeadId?._id || assignment.LeadId;
//             return assignmentLeadId === lead?.leadId;
//         }));

//         if (flattenedData.length === 0) {
//             console.error('No data to export');
//             alert('No assignment data available to export');
//             return;
//         }

//         const ws = XLSX.utils.json_to_sheet(flattenedData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, 'Lead Assignments');
//         XLSX.writeFile(wb, `lead_assignments_${lead?.name || 'unknown'}.xlsx`);
//     };

//     if (loading) {
//         return (
//             <Modal show={show} onHide={onHide} size="xl" centered>
//                 <Modal.Body>
//                     <Container className="startpage text-center">
//                         <Spinner animation="border" style={{color:"#102dff"}} />
//                         <p className="mt-3">Loading Lead Data</p>
//                     </Container>
//                 </Modal.Body>
//             </Modal>
//         );
//     }

//     if (!lead) return null;

//     const copyToClipboard = (number) => {
//         navigator.clipboard.writeText(number);
//         alert("Number copied: " + number);
//     };

//     return (
//         <Modal style={{zIndex:"20000"}} show={show} onHide={onHide} size="xl" centered scrollable>
//             <Modal.Header closeButton style={{
//                 backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff",
//                 color: mode === "dark" ? "#e0e0e0" : "#333333"
//             }}>
//                 <Modal.Title className="fw-bold" style={{color:"#102dff"}}>
//                     Lead Full Preview - {lead.name}
//                 </Modal.Title>
//             </Modal.Header>

//             <Modal.Body style={{
//                 backgroundColor: mode === "dark" ? "#1e1e1e" : "#f8f9fa",
//                 color: mode === "dark" ? "#e0e0e0" : "#333333",
//                 maxHeight: '80vh',
//                 overflowY: 'auto'
//             }}>

//                 {/* Lead Assignment History Section - محسنة */}
//                 <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100" style={{ backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333", boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
//                     <div className="d-flex justify-content-between align-items-center mb-4">
//                         <h5 className="fw-bold text-primary mb-0">
//                             <span className="text-decoration-underline" style={{color:"#102dff"}}>
//                                 <FaHistory className="me-2" />
//                                 Lead Assignment History
//                                 {assignmentLoading ? (
//                                     <Spinner animation="border" size="sm" className="ms-2" />
//                                 ) : (
//                                     ` (${totalAssignments})`
//                                 )}
//                             </span>
//                         </h5>

//                         {/* زر التصدير */}
//                         {leadAssignmentHistory.length > 0 && (
//                             <button
//                                 onClick={exportToExcel}
//                                 className="btn btn-sm"
//                                 style={{
//                                     background: '#0F7687',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '8px 16px',
//                                     borderRadius: '5px',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '8px'
//                                 }}
//                             >
//                                 Export Excel <GetAppIcon fontSize="small" />
//                             </button>
//                         )}
//                     </div>

//                     {assignmentLoading ? (
//                         <div className="text-center p-4">
//                             <Spinner animation="border" style={{color:"#102dff"}} />
//                             <p className="mt-2">Loading assignment history...</p>
//                         </div>
//                     ) : leadAssignmentHistory.length > 0 ? (
//                         <>
//                             <div className="table-responsive">
//                                 <Table
//                                     key={`assignment-table-${lead?._id}-${leadAssignmentHistory.length}`}
//                                     striped bordered hover responsive
//                                     style={{
//                                         backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff",
//                                         color: mode === "dark" ? "#e0e0e0" : "#333333"
//                                     }}
//                                 >
//                                     <thead style={{
//                                         backgroundColor: mode === "dark" ? "#333" : "#f5f5f5"
//                                     }}>
//                                         <tr>
//                                             <th style={{
//                                                 color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                 fontWeight: 'bold'
//                                             }}>#</th>
//                                             <th style={{
//                                                 color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                 fontWeight: 'bold'
//                                             }}>Assigned To</th>
//                                             <th style={{
//                                                 color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                 fontWeight: 'bold'
//                                             }}>Assigned From</th>
//                                             <th style={{
//                                                 color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                 fontWeight: 'bold'
//                                             }}>Assignment Date</th>
//                                             <th style={{
//                                                 color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                 fontWeight: 'bold'
//                                             }}>Status</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {leadAssignmentHistory.map((assignment, index) => {
//                                             const isCurrent = index === 0; // الأحدث هو الحالي
//                                             return (
//                                                 <tr key={`${assignment.id}-${index}`}
//                                                     style={{
//                                                         backgroundColor: isCurrent ?
//                                                             (mode === "dark" ? "rgba(16, 45, 255, 0.1)" : "rgba(16, 45, 255, 0.05)") :
//                                                             (index % 2 === 0 ?
//                                                                 (mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)") :
//                                                                 'transparent')
//                                                     }}>
//                                                     <td style={{
//                                                         color: mode === "dark" ? "#e0e0e0" : "#333",
//                                                         fontWeight: 'medium',
//                                                         textAlign: 'center'
//                                                     }}>
//                                                         {index + 1}
//                                                     </td>
//                                                     <td>
//                                                         <div className="d-flex align-items-center">
//                                                             <Avatar
//                                                                 sx={{
//                                                                     width: 32,
//                                                                     height: 32,
//                                                                     fontSize: '0.7rem',
//                                                                     backgroundColor: getAvatarColor(assignment.salesName),
//                                                                     border: `2px solid ${mode === "dark" ? "#444" : "#fff"}`,
//                                                                     marginRight: 2
//                                                                 }}
//                                                                 title={assignment.salesName}
//                                                             >
//                                                                 {getInitials(assignment.salesName)}
//                                                             </Avatar>
//                                                             <div>
//                                                                 <span style={{ color: mode === "dark" ? "#e0e0e0" : "#333" }}>
//                                                                     {assignment.salesName}
//                                                                 </span>
//                                                                 {isCurrent && (
//                                                                     <Badge bg="success" className="ms-2" style={{fontSize: '0.6rem'}}>
//                                                                         Current
//                                                                     </Badge>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td style={{ color: mode === "dark" ? "#e0e0e0" : "#333" }}>
//                                                         {assignment.assignedFrom}
//                                                     </td>
//                                                     <td style={{ color: mode === "dark" ? "#e0e0e0" : "#333" }}>
//                                                         {assignment.date}
//                                                     </td>
//                                                     <td>
//                                                         <Badge
//                                                             bg={isCurrent ? "success" : "secondary"}
//                                                             text={isCurrent ? "white" : "white"}
//                                                         >
//                                                             {isCurrent ? "Active" : "Previous"}
//                                                         </Badge>
//                                                     </td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </Table>
//                             </div>

//                             {/* Summary Stats */}
//                             <div className="row mt-4">
//                                 <div className="col-md-3">
//                                     <div className="text-center p-3 rounded" style={{
//                                         backgroundColor: mode === "dark" ? "#333" : "#f8f9fa",
//                                         border: `1px solid ${mode === "dark" ? "#444" : "#dee2e6"}`
//                                     }}>
//                                         <h6 style={{ color: '#102dff', fontWeight: 'bold', margin: 0 }}>
//                                             {totalAssignments}
//                                         </h6>
//                                         <small style={{ color: mode === "dark" ? "#999" : "#666" }}>
//                                             Total Assignments
//                                         </small>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-3">
//                                     <div className="text-center p-3 rounded" style={{
//                                         backgroundColor: mode === "dark" ? "#333" : "#f8f9fa",
//                                         border: `1px solid ${mode === "dark" ? "#444" : "#dee2e6"}`
//                                     }}>
//                                         <h6 style={{ color: '#2196f3', fontWeight: 'bold', margin: 0 }}>
//                                             {uniqueSales}
//                                         </h6>
//                                         <small style={{ color: mode === "dark" ? "#999" : "#666" }}>
//                                             Unique Sales
//                                         </small>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-3">
//                                     <div className="text-center p-3 rounded" style={{
//                                         backgroundColor: mode === "dark" ? "#333" : "#f8f9fa",
//                                         border: `1px solid ${mode === "dark" ? "#444" : "#dee2e6"}`
//                                     }}>
//                                         <h6 style={{ color: '#4caf50', fontWeight: 'bold', margin: 0 }}>
//                                             {leadAssignmentHistory[0]?.salesName || 'N/A'}
//                                         </h6>
//                                         <small style={{ color: mode === "dark" ? "#999" : "#666" }}>
//                                             Current Sales
//                                         </small>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-3">
//                                     <div className="text-center p-3 rounded" style={{
//                                         backgroundColor: mode === "dark" ? "#333" : "#f8f9fa",
//                                         border: `1px solid ${mode === "dark" ? "#444" : "#dee2e6"}`
//                                     }}>
//                                         <h6 style={{ color: '#ff9800', fontWeight: 'bold', margin: 0 }}>
//                                             {leadAssignmentHistory[leadAssignmentHistory.length - 1]?.salesName || 'N/A'}
//                                         </h6>
//                                         <small style={{ color: mode === "dark" ? "#999" : "#666" }}>
//                                             First Sales
//                                         </small>
//                                     </div>
//                                 </div>
//                             </div>
//                         </>
//                     ) : (
//                         <div className="text-center p-5" style={{ color: mode === "dark" ? "#999" : "#666" }}>
//                             <FaHistory size={48} className="mb-3 opacity-50" />
//                             <p className="mb-0">No assignment history found for this lead</p>
//                             <small>Lead ID: {lead?._id}</small>
//                             <br />
//                             <small>Lead Name: {lead?.name}</small>
//                             <br />
//                             <small>Total assignments in Redux: {LeadAssignedarray.length} records</small>
//                         </div>
//                     )}
//                 </div>

//                 {/* Basic Info */}
//                 <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100" style={{ backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333", boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
//                     <h5 className="mb-4 fw-bold text-primary">
//                         <span className="text-decoration-underline" style={{color:"#102dff"}}>Basic Information</span>
//                     </h5>
//                     <Row className="gy-3 gx-4">
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><FaUserAlt className="text-info me-2" /><strong>Name:</strong> {lead.name}</div></Col>

//                         <Col xs={12} md={6}>
//                             <div className="d-flex align-items-center">
//                                 <FaPhone className="text-success me-2" />
//                                 <strong>Phone:</strong> {lead.phone}
//                                 <a
//                                     href={`https://wa.me/${lead.phone}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="ms-2 text-success"
//                                 >
//                                     <FaWhatsapp size={20} />
//                                 </a>
//                                 <FaCopy
//                                     size={18}
//                                     className="ms-2 text-primary"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => copyToClipboard(lead.phone)}
//                                 />
//                             </div>
//                         </Col>

//                         <Col xs={12} md={6}>
//                             <div className="d-flex align-items-center">
//                                 <FaPhone className="text-success me-2" />
//                                 <strong>Phone2:</strong> {lead.phonenumber2 ? lead.phonenumber2 : lead.phone}
//                                 <a
//                                     href={`https://wa.me/${lead.phonenumber2 ? lead.phonenumber2 : lead.phone}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="ms-2 text-success"
//                                 >
//                                     <FaWhatsapp size={20} />
//                                 </a>
//                                 <FaCopy
//                                     size={18}
//                                     className="ms-2 text-primary"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => copyToClipboard(lead.phonenumber2 ? lead.phonenumber2 : lead.phone)}
//                                 />
//                             </div>
//                         </Col>

//                         <Col xs={12} md={6}>
//                             <div className="d-flex align-items-center">
//                                 <FaPhone className="text-success me-2" />
//                                 <strong>Whatsapp Number:</strong> {lead.whatsappnumber ? lead.whatsappnumber : lead.phone}
//                                 <a
//                                     href={`https://wa.me/${lead.whatsappnumber ? lead.whatsappnumber : lead.phone}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="ms-2 text-success"
//                                 >
//                                     <FaWhatsapp size={20} />
//                                 </a>
//                                 <FaCopy
//                                     size={18}
//                                     className="ms-2 text-primary"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => copyToClipboard(lead.whatsappnumber ? lead.whatsappnumber : lead.phone)}
//                                 />
//                             </div>
//                         </Col>

//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><FaEnvelope className="text-danger me-2" /><strong>Email:</strong> {lead.email?(lead.email):"Not Exist"}</div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><FaProjectDiagram className="text-warning me-2" /><strong>Project:</strong> {lead.project}</div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><FaUserAlt className="text-primary me-2" /><strong>Developer:</strong> {lead?.developer?.name}</div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><FaCalendarAlt className="text-secondary me-2" /><strong>Created At:</strong> {lead ? moment(lead.createdAt).format('DD/MM/YYYY h:mm A') :  <Skeleton animation="wave" />} </div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><strong>Current Sales:</strong> <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">{lead.currentSales}</Badge></div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><strong>Last Sales:</strong> <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">{lead.lastSales}</Badge></div></Col>
//                         <Col xs={12} md={6}><div className="d-flex align-items-center"><strong>Last Date Assigned:</strong> <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">{lead ? moment(lead.lastdateusedtoassigned).format('DD/MM/YYYY h:mm A'):  <Skeleton animation="wave" />}</Badge></div></Col>
//                     </Row>
//                 </div>

//                 {/* Lead With Sales (Period) */}
//                 <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100" style={{ backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333", boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
//                     <h5 className="mb-4 fw-bold text-primary">
//                         <span className="text-decoration-underline" style={{color:"#102dff"}}>Lead With Sales (Period)</span>
//                     </h5>

//                     <Row xs={1} md={2} lg={3} className="g-4">
//                         {lead.salesAssignDurations?.map((sales, idx) => (
//                             <Col key={`${sales.name}-${idx}`}>
//                                 <Card className="shadow rounded h-100 w-100" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}} >
//                                     <div className="d-flex flex-column w-100">
//                                         <Card.Title className="d-flex justify-content-between align-items-center" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                             <span>{sales.name}</span>
//                                             <Badge style={{background:"#666"}} pill>
//                                                 {sales.periods?.length || 0} {sales.periods?.length > 1 ? "Periods" : "Period"}
//                                             </Badge>
//                                         </Card.Title>

//                                         <Card.Subtitle className="mb-3 " style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                             <div className="d-flex align-items-center" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                 <FaClock className="me-2" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}/>
//                                                 Total: {sales.totalDuration}
//                                             </div>
//                                         </Card.Subtitle>

//                                         <hr />

//                                         <div className="flex-grow-1 overflow-auto" style={{ maxHeight: '300px',background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333" }}>
//                                             <h6 className="fw-bold" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>Period Details:</h6>
//                                             <ListGroup variant="flush" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                 {sales.periods?.map((p, i) => (
//                                                     <ListGroup.Item key={i} className="py-2 px-0" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                         <div className="d-flex justify-content-between small mb-1" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                             <span className="" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>From:</span>
//                                                             <strong style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                                 {new Date(p.from).toLocaleString('en-US', {
//                                                                     year: 'numeric',
//                                                                     month: 'short',
//                                                                     day: 'numeric',
//                                                                     hour: '2-digit',
//                                                                     minute: '2-digit'
//                                                                 })}
//                                                             </strong>
//                                                         </div>

//                                                         <div className="d-flex justify-content-between small mb-1" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                             <span className="" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>To:</span>
//                                                             <strong style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                                 {new Date(p.to).toLocaleString('en-US', {
//                                                                     year: 'numeric',
//                                                                     month: 'short',
//                                                                     day: 'numeric',
//                                                                     hour: '2-digit',
//                                                                     minute: '2-digit'
//                                                                 })}
//                                                             </strong>
//                                                         </div>

//                                                         <div className="d-flex justify-content-between small" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                             <span className="" style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>Duration:</span>
//                                                             <Badge bg="info" className="text-dark">
//                                                                 {p.durationStr}
//                                                             </Badge>
//                                                         </div>

//                                                         {i < sales.periods.length - 1 && <hr className="my-2" />}
//                                                     </ListGroup.Item>
//                                                 ))}
//                                             </ListGroup>
//                                         </div>
//                                     </div>
//                                 </Card>
//                             </Col>
//                         ))}
//                     </Row>
//                 </div>

//                 {/* Stages Durations */}
//                 {lead.salesDurations && (
//                     <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100 my-4" style={{ backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333" }}>
//                         <h5 className="mb-4 fw-bold text-primary">
//                             <span className="text-decoration-underline" style={{color:"#102dff"}}>Stages Durations (Full)</span>
//                         </h5>

//                         <Row className="gy-4">
//                             {Object.entries(lead.salesDurations).map(([salesId, salesData], index) => {
//                                 const currentSalesName = salesData.name;

//                                 const lastAssignForThisSales = lead.allAssignPeriods
//                                     ?.filter(p => p.salesName === currentSalesName)
//                                     ?.sort((a, b) => new Date(b.from) - new Date(a.from))[0];

//                                 return (
//                                     <Col xs={12} key={`${salesId}-${index}`}>
//                                         <div className="d-flex justify-content-between align-items-center mb-3">
//                                             <h6 className="fw-bold text-secondary mb-0">
//                                                 👤 Sales: {salesData.name}
//                                             </h6>
//                                             <Badge style={{background:"#102dff"}} className="fs-6">
//                                                 {salesData.interactions?.length || 0} Stages
//                                             </Badge>
//                                         </div>

//                                         {salesData.interactions?.length > 0 ? (
//                                             <div className="table-responsive">
//                                                 <table
//                                                     className="table table-bordered"
//                                                     style={{
//                                                         backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//                                                         color: mode === 'dark' ? '#e0e0e0' : '#212529',
//                                                     }}
//                                                 >
//                                                     <thead
//                                                         style={{
//                                                             backgroundColor: mode === 'dark' ? '#3d3d3d' : '#f8f9fa',
//                                                             color: mode === 'dark' ? '#ffffff' : '#000000',
//                                                         }}
//                                                     >
//                                                         <tr>
//                                                             <th style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}> Stage</th>
//                                                             <th style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>From</th>
//                                                             <th style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>To</th>
//                                                             <th style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>Duration</th>
//                                                             <th style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>Status</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {salesData.interactions.map((interaction, idx) => {
//                                                             const from = new Date(interaction.from);
//                                                             let to = new Date(interaction.to);
//                                                             let status = 'Completed';

//                                                             if (idx === salesData.interactions.length - 1) {
//                                                                 const nextAssign = lead.allAssignPeriods?.find(
//                                                                     (p) => new Date(p.from) > new Date(lastAssignForThisSales?.from)
//                                                                 );

//                                                                 if (nextAssign) {
//                                                                     to = new Date(lastAssignForThisSales?.to || interaction.to);
//                                                                     status = 'Ended by Reassignment';
//                                                                 } else if (!interaction.to) {
//                                                                     status = 'Current Stage';
//                                                                 }
//                                                             }

//                                                             const durationMs = to - from;
//                                                             const durationStr = formatDuration(durationMs);

//                                                             return (
//                                                                 <tr
//                                                                     key={idx}
//                                                                     style={{
//                                                                         backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//                                                                         color: mode === 'dark' ? '#cccccc' : '#212529',
//                                                                     }}
//                                                                 >
//                                                                     <td style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>{interaction.stage}</td>
//                                                                     <td style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>{formatDateTime(from)}</td>
//                                                                     <td style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>{to ? formatDateTime(to) : 'Current'}</td>
//                                                                     <td style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>{durationStr}</td>
//                                                                     <td style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>
//                                                                         <Badge
//                                                                             bg={
//                                                                                 status === 'Completed'
//                                                                                     ? 'success'
//                                                                                     : status === 'Ended by Reassignment'
//                                                                                     ? 'dark'
//                                                                                     : 'primary'
//                                                                             }
//                                                                         >
//                                                                             {status}
//                                                                         </Badge>
//                                                                     </td>
//                                                                 </tr>
//                                                             );
//                                                         })}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         ) : (
//                                             <div
//                                                 className="p-3 rounded"
//                                                 style={{
//                                                     backgroundColor: mode === 'dark' ? '#444' : '#f8f9fa',
//                                                     color: mode === 'dark' ? '#ccc' : '#666',
//                                                 }}
//                                             >
//                                                 No stages found for this sales.
//                                             </div>
//                                         )}

//                                         {lastAssignForThisSales && (
//                                             <div
//                                                 className="mt-3 p-3 rounded"
//                                                 style={{
//                                                     backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff",
//                                                     color: mode === "dark" ? "#e0e0e0" : "#333333",
//                                                     border: mode === "dark" ? "1px solid #444" : "1px solid #ddd",
//                                                 }}
//                                             >
//                                                 <div className="d-flex justify-content-between">
//                                                     <span className="fw-bold">Last Assignment Period:</span>
//                                                     <Badge bg={mode === "dark" ? "light" : "secondary"} text={mode === "dark" ? "dark" : "white"}>
//                                                         {formatDuration(new Date(lastAssignForThisSales.to || new Date()) - new Date(lastAssignForThisSales.from))}
//                                                     </Badge>
//                                                 </div>
//                                                 <div className="small mt-2">
//                                                     <span style={{ color: mode === "dark" ? "#aaaaaa" : "#666" }}>From:</span>{' '}
//                                                     {formatDateTime(new Date(lastAssignForThisSales.from))}<br />
//                                                     <span style={{ color: mode === "dark" ? "#aaaaaa" : "#666" }}>To:</span>{' '}
//                                                     {lastAssignForThisSales.to
//                                                         ? formatDateTime(new Date(lastAssignForThisSales.to))
//                                                         : 'Current'}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </Col>
//                                 );
//                             })}
//                         </Row>
//                     </div>
//                 )}

//                 {/* Stages Passed */}
//                 <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100" style={{ backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333", boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
//                     <h5 className="mt-2 mb-3 fw-bold text-primary">
//                         <span className="text-decoration-underline"  style={{color:"#102dff"}}>Stages Passed</span>
//                     </h5>
//                     <Row className="gy-3 gx-4">
//                         {lead.stagesPassed?.map((stage, index) => (
//                             <Col xs={12} md={4} key={index}>
//                                 <div className="shadow-sm  p-2"  style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333",borderRadius:'10px',border:'1px solid #102dff'}} >
//                                     <Card.Body>
//                                         <div className="fw-bold "  style={{color:"#666"}}>{stage.stage}</div>
//                                         <Card.Subtitle className="mb-2 "  style={{background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333"}}>{stage ? moment(stage.date).format('DD/MM/YYYY') :  <Skeleton animation="wave" />}</Card.Subtitle>
//                                         <Card.Text><strong>Sales:</strong> {stage.sales}</Card.Text>
//                                     </Card.Body>
//                                 </div>
//                             </Col>
//                         ))}
//                     </Row>
//                 </div>

//                 {/* Comments Section */}
//                 <div className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100" style={{backgroundColor: mode === "dark" ? "#2d2d2d" : "#ffffff", color: mode === "dark" ? "#e0e0e0" : "#333333", boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
//                     <h5 className="mt-2 mb-3 fw-bold text-primary">
//                         <span className="text-decoration-underline" style={{color:"#102dff"}}>Comments ({lead.comments?.length || 0})</span>
//                     </h5>

//                     <div style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '10px' }} >
//                         <Row className="gy-3 gx-4" >
//                             {lead.comments?.map((comment, index) => (
//                                 <Col xs={12} key={index} >
//                                     <div className="mb-4" >
//                                         {/* First Comment */}
//                                         <div className="d-flex align-items-start mb-3">
//                                             <Badge style={{background:"#102dff"}} className="me-2">Comment</Badge>
//                                             <Image
//                                                 src={comment.sales.profileImg ? getCleanImageUrl(comment.sales.profileImg) : 'path/to/default-image.jpg'}
//                                                 alt={comment.sales.name}
//                                                 roundedCircle
//                                                 width={40}
//                                                 height={40}
//                                                 className="me-3"
//                                             />
//                                             <div className="w-100" >
//                                                 <div className="d-flex justify-content-between align-items-center" >
//                                                     <div>
//                                                         <strong style={{color:mode==="dark"?"#fff":"#333"}}> {index + 1}. {comment.sales.name}</strong>
//                                                         <div className="" style={{ fontSize: '0.85rem',color:mode==="dark"?"#fff":"#333" }}>{comment.sales.email}</div>
//                                                     </div>
//                                                     <small className="" style={{color:mode==="dark"?"#fff":"#333"}}>{new Date(comment.firstcomment.date).toLocaleString()}</small>
//                                                 </div>
//                                                 <div className=" p-3 rounded-3 mt-2" style={{ maxWidth: '75%',background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333" }}>
//                                                     <p className="mb-0" style={{color:mode==="dark"?"#fff":"#333"}} >{comment.firstcomment.text}</p>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Second Comment */}
//                                         {comment.secondcomment && (
//                                             <div className="d-flex align-items-start mb-3 ms-5">
//                                                 <Badge style={{background:"#102dff"}} className="me-2">Next Action</Badge>
//                                                 <Image
//                                                     src={comment.sales.profileImg ? getCleanImageUrl(comment.sales.profileImg) : 'path/to/default-image.jpg'}
//                                                     alt={comment.sales.name}
//                                                     roundedCircle
//                                                     width={35}
//                                                     height={35}
//                                                     className="me-3"
//                                                 />
//                                                 <div className="w-100">
//                                                     <div className="d-flex justify-content-between align-items-center">
//                                                         <div>
//                                                             <strong style={{color:mode==="dark"?"#fff":"#333"}}>{comment.sales.name}</strong>
//                                                             <div className="" style={{ fontSize: '0.8rem',color:mode==="dark"?"#fff":"#333" }}>{comment.sales.email}</div>
//                                                         </div>
//                                                         <small style={{color:mode==="dark"?"#fff":"#333"}} className="">{new Date(comment.secondcomment.date).toLocaleString()}</small>
//                                                     </div>
//                                                     <div  className=" p-3 rounded-3 mt-2" style={{ maxWidth: '70%',background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333" }}>
//                                                         <p style={{color:mode==="dark"?"#fff":"#333"}} className="mb-0">{comment.secondcomment.text}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                         <Divider/>
//                                         {/* Replies */}
//                                         {comment.replies?.length > 0 && (
//                                             <div className="ms-5 mt-3">
//                                                 <h6 className="text-secondary fw-bold mb-2">Replies ({comment.replies.length})</h6>
//                                                 {comment.replies.map((reply, idx) => (
//                                                     <div className="d-flex align-items-start mb-3 ms-4" key={idx}>
//                                                         <Image
//                                                             src={reply?.user?.profileImg ? getCleanImageUrl(reply?.user?.profileImg) : 'path/to/default-image.jpg'}
//                                                             alt={reply?.user?.name}
//                                                             roundedCircle
//                                                             width={32}
//                                                             height={32}
//                                                             className="me-3"
//                                                         />
//                                                         <div className="w-100">
//                                                             <div className="d-flex justify-content-between align-items-center">
//                                                                 <div>
//                                                                     <strong>{reply.user.name}</strong>
//                                                                     <span className="badge bg-light text-dark ms-2">Reply</span>
//                                                                 </div>
//                                                                 <small style={{color:mode==="dark"?"#fff":"#333"}} className="">{new Date(reply.date).toLocaleString()}</small>
//                                                             </div>
//                                                             <div className=" p-2 rounded-3 mt-2" style={{ maxWidth: '65%',background:mode==="dark"?"#333":"#fff",color:mode==="dark"?"#fff":"#333" }}>
//                                                                 <p style={{color:mode==="dark"?"#fff":"#333"}} className="mb-0">{reply.text}</p>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             ))}
//                         </Row>
//                     </div>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// };






















// before 20-5-2026


// import React, { useEffect, useState } from 'react';
// import {
//   Modal,
//   Box,
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   CircularProgress,
//   Avatar,
//   IconButton,
//   Tooltip,
//   Divider,
//   Paper,
//   Badge,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Skeleton,
//   alpha,
//   Zoom,
//   Fade,
//   Slide,
//   Grow,
// } from '@mui/material';
// import { styled, useTheme } from '@mui/material/styles';
// import {
//   Phone as PhoneIcon,
//   ContentCopy as CopyIcon,
//   WhatsApp as WhatsAppIcon,
//   Email as EmailIcon,
//   AccountTree as ProjectIcon,
//   Person as PersonIcon,
//   CalendarToday as CalendarIcon,
//   AccessTime as ClockIcon,
//   History as HistoryIcon,
//   GetApp as DownloadIcon,
//   Schedule as ScheduleIcon,
//   Assignment as AssignmentIcon,
//   Comment as CommentIcon,
//   Reply as ReplyIcon,
// } from '@mui/icons-material';
// import XLSX from '../utils/excelUtils';
// import moment from 'moment';
// import { db_url } from '../Api/BaseUrl';
// import { useSelector, useDispatch } from 'react-redux';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';

// // Styled Components
// const StyledModal = styled(Modal)(({ theme }) => ({
//   '& .MuiBackdrop-root': {
//     backdropFilter: 'blur(8px)',
//     backgroundColor: alpha(theme.palette.common.black, 0.5),
//   },
// }));

// const ModalContainer = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '90%',
//   maxWidth: '1400px',
//   maxHeight: '90vh',
//   overflowY: 'auto',
//   backgroundColor: theme.palette.background.paper,
//   borderRadius: theme.spacing(3),
//   boxShadow: theme.shadows[24],
//   padding: theme.spacing(4),
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     background: theme.palette.background.default,
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     background: theme.palette.primary.main,
//     borderRadius: '4px',
//     '&:hover': {
//       background: theme.palette.primary.dark,
//     },
//   },
// }));

// const InfoCard = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   borderRadius: theme.spacing(2),
//   boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.12)}`,
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'translateY(-4px)',
//     boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.2)}`,
//   },
// }));

// const InfoItem = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(1.5),
//   padding: theme.spacing(1.5),
//   borderRadius: theme.spacing(1.5),
//   backgroundColor: alpha(theme.palette.primary.main, 0.04),
//   transition: 'background-color 0.2s ease',
//   '&:hover': {
//     backgroundColor: alpha(theme.palette.primary.main, 0.08),
//   },
// }));

// const CommentBubble = styled(Box)(({ theme, isOwn }) => ({
//   maxWidth: '80%',
//   padding: theme.spacing(2),
//   borderRadius: theme.spacing(2),
//   backgroundColor: isOwn
//     ? alpha(theme.palette.primary.main, 0.12)
//     : alpha(theme.palette.grey[500], 0.08),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   backdropFilter: 'blur(4px)',
//   transition: 'transform 0.2s ease',
//   position: 'relative',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 12,
//     left: -8,
//     width: 0,
//     height: 0,
//     borderStyle: 'solid',
//     borderWidth: '8px 8px 8px 0',
//     borderColor: `transparent ${isOwn ? alpha(theme.palette.primary.main, 0.12) : alpha(theme.palette.grey[500], 0.08)} transparent transparent`,
//   },
//   '&:hover': {
//     transform: 'scale(1.01)',
//   },
// }));

// const StyledChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 600,
//   borderRadius: theme.spacing(1),
//   ...(status === 'current' && {
//     background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
//     color: theme.palette.common.white,
//   }),
//   ...(status === 'previous' && {
//     background: theme.palette.grey[200],
//     color: theme.palette.text.secondary,
//   }),
// }));

// const AnimatedCard = styled(Card)(({ theme }) => ({
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'translateY(-4px) scale(1.02)',
//     boxShadow: theme.shadows[12],
//   },
// }));

// const StatCard = styled(Paper)(({ theme, color }) => ({
//   padding: theme.spacing(2),
//   textAlign: 'center',
//   backgroundColor: alpha(color || theme.palette.primary.main, 0.08),
//   borderRadius: theme.spacing(2),
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'scale(1.05)',
//     backgroundColor: alpha(color || theme.palette.primary.main, 0.12),
//   },
// }));

// // Helper Functions
// const getInitials = (name) => {
//   if (!name) return '?';
//   return name
//     .split(' ')
//     .map((word) => word[0])
//     .join('')
//     .toUpperCase()
//     .slice(0, 2);
// };

// const getAvatarColor = (name) => {
//   const colors = [
//     '#2196f3',
//     '#ff9800',
//     '#4caf50',
//     '#f44336',
//     '#9c27b0',
//     '#00bcd4',
//     '#ffeb3b',
//     '#795548',
//     '#607d8b',
//     '#3f51b5',
//   ];
//   let hash = 0;
//   for (let i = 0; i < name.length; i++) {
//     hash = name.charCodeAt(i) + ((hash << 5) - hash);
//   }
//   return colors[Math.abs(hash) % colors.length];
// };

// const formatDateTime = (date) => {
//   if (!date) return '—';
//   return moment(date).format('DD/MM/YYYY hh:mm:ss A');
// };

// const formatDuration = (ms) => {
//   if (isNaN(ms)) return '—';
//   const seconds = Math.floor(ms / 1000);
//   const minutes = Math.floor(seconds / 60);
//   const hours = Math.floor(minutes / 60);
//   const days = Math.floor(hours / 24);

//   return (
//     [
//       days > 0 ? `${days}d` : null,
//       hours % 24 > 0 ? `${hours % 24}h` : null,
//       minutes % 60 > 0 ? `${minutes % 60}m` : null,
//       seconds % 60 > 0 ? `${seconds % 60}s` : null,
//     ]
//       .filter(Boolean)
//       .join(' ') || '0s'
//   );
// };

// export const PreviewLeadModal = ({ show, onHide, lead, loading }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const [assignmentLoading, setAssignmentLoading] = useState(false);
//   const [hoveredSection, setHoveredSection] = useState(null);

//   const resleadassigned = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);
//   const LeadAssignedarray = Array.isArray(resleadassigned?.data) ? resleadassigned.data : [];

//   useEffect(() => {
//     if (show && lead?.leadId) {
//       const fetchAssignmentData = async () => {
//         setAssignmentLoading(true);
//         try {
//           await dispatch(Get_All_Lead_Assigned_Data_Action(lead.leadId));
//         } catch (error) {
//           console.error('Error fetching assignment data:', error);
//         } finally {
//           setAssignmentLoading(false);
//         }
//       };
//       fetchAssignmentData();
//     }
//   }, [show, lead?.leadId, dispatch]);

//   const getCleanImageUrl = (filename) => {
//     if (!filename) return null;
//     return `${db_url}/UsersImages/${filename}`;
//   };

//   const transformAssignmentData = () => {
//     if (!Array.isArray(LeadAssignedarray) || !lead?.leadId) return [];

//     const currentLeadAssignments = LeadAssignedarray.filter((assignment) => {
//       const assignmentLeadId = assignment.LeadId?._id || assignment.LeadId;
//       return assignmentLeadId === lead.leadId;
//     });

//     return currentLeadAssignments
//       .sort(
//         (a, b) =>
//           new Date(b.date_Assigned || b.createdAt) - new Date(a.date_Assigned || a.createdAt),
//       )
//       .map((assignment, index) => ({
//         id: assignment._id || index,
//         salesName: assignment.Assigned_to?.name || 'Unknown',
//         assignedFrom: assignment.Assigned_From?.name || 'Unknown',
//         date: assignment.assignDateTime || assignment.createdAt,
//         type: 'Assigned',
//       }));
//   };

//   const leadAssignmentHistory = transformAssignmentData();
//   const totalAssignments = leadAssignmentHistory.length;
//   const uniqueSales = new Set(leadAssignmentHistory.map((a) => a.salesName)).size;

//   const exportToExcel = () => {
//     const data = leadAssignmentHistory.map((item) => ({
//       'Sales Name': item.salesName,
//       'Assigned From': item.assignedFrom,
//       'Assignment Date': formatDateTime(item.date),
//     }));

//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Lead Assignments');
//     XLSX.writeFile(wb, `lead_assignments_${lead?.name || 'unknown'}.xlsx`);
//   };

//   const copyToClipboard = (number) => {
//     navigator.clipboard.writeText(number);
//     // يمكن إضافة Snackbar هنا للإشعار
//   };

//   if (loading) {
//     return (
//       <StyledModal open={show} onClose={onHide}>
//         <ModalContainer>
//           <Fade in={loading}>
//             <Box
//               display="flex"
//               flexDirection="column"
//               alignItems="center"
//               justifyContent="center"
//               minHeight="400px"
//             >
//               <CircularProgress size={60} thickness={4} />
//               <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
//                 Loading Lead Data...
//               </Typography>
//             </Box>
//           </Fade>
//         </ModalContainer>
//       </StyledModal>
//     );
//   }

//   if (!lead) return null;

//   return (
//     <StyledModal open={show} onClose={onHide}>
//       <ModalContainer>
//         {/* Header */}
//         <Fade in={true} timeout={500}>
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
//             <Typography variant="h4" fontWeight="bold" color="primary">
//               {lead.name}
//             </Typography>
//             <Chip
//               label={`Lead ID: ${lead._id?.slice(-6)}`}
//               color="primary"
//               variant="outlined"
//               size="small"
//               sx={{ borderRadius: 2 }}
//             />
//           </Box>
//         </Fade>

//         {/* Assignment History Section */}
//         <Grow in={true} timeout={600}>
//           <InfoCard sx={{ mb: 4 }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <HistoryIcon color="primary" />
//                 <Typography variant="h6" fontWeight="600">
//                   Assignment History
//                 </Typography>
//                 {assignmentLoading ? (
//                   <CircularProgress size={20} />
//                 ) : (
//                   <Chip
//                     label={`${totalAssignments} assignments`}
//                     size="small"
//                     color="primary"
//                     sx={{ borderRadius: 2 }}
//                   />
//                 )}
//               </Box>
//               {leadAssignmentHistory.length > 0 && (
//                 <Tooltip title="Export to Excel" arrow>
//                   <IconButton
//                     onClick={exportToExcel}
//                     color="primary"
//                     sx={{
//                       transition: 'transform 0.2s',
//                       '&:hover': { transform: 'scale(1.1)' },
//                     }}
//                   >
//                     <DownloadIcon />
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Box>

//             {assignmentLoading ? (
//               <Box textAlign="center" py={4}>
//                 <CircularProgress />
//                 <Typography sx={{ mt: 2 }}>Loading assignment history...</Typography>
//               </Box>
//             ) : leadAssignmentHistory.length > 0 ? (
//               <>
//                 <TableContainer
//                   component={Paper}
//                   elevation={0}
//                   sx={{
//                     borderRadius: 2,
//                     overflow: 'hidden',
//                     border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                   }}
//                 >
//                   <Table>
//                     <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.08) }}>
//                       <TableRow>
//                         <TableCell>#</TableCell>
//                         <TableCell>Assigned To</TableCell>
//                         <TableCell>Assigned From</TableCell>
//                         <TableCell>Assignment Date</TableCell>
//                         <TableCell>Status</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {leadAssignmentHistory.map((assignment, index) => {
//                         const isCurrent = index === 0;
//                         return (
//                           <TableRow
//                             key={`${assignment.id}-${index}`}
//                             sx={{
//                               bgcolor: isCurrent
//                                 ? alpha(theme.palette.success.main, 0.08)
//                                 : 'inherit',
//                               transition: 'background-color 0.3s',
//                               '&:hover': {
//                                 bgcolor: alpha(theme.palette.primary.main, 0.04),
//                               },
//                             }}
//                           >
//                             <TableCell>{index + 1}</TableCell>
//                             <TableCell>
//                               <Box display="flex" alignItems="center" gap={1.5}>
//                                 <Avatar
//                                   sx={{
//                                     width: 32,
//                                     height: 32,
//                                     bgcolor: getAvatarColor(assignment.salesName),
//                                     fontSize: '0.75rem',
//                                     transition: 'transform 0.2s',
//                                     '&:hover': { transform: 'scale(1.1)' },
//                                   }}
//                                 >
//                                   {getInitials(assignment.salesName)}
//                                 </Avatar>
//                                 <Box>
//                                   <Typography variant="body2" fontWeight={isCurrent ? 600 : 400}>
//                                     {assignment.salesName}
//                                   </Typography>
//                                   {isCurrent && (
//                                     <Chip
//                                       label="Current"
//                                       size="small"
//                                       color="success"
//                                       sx={{ height: 20, fontSize: '0.625rem', borderRadius: 1 }}
//                                     />
//                                   )}
//                                 </Box>
//                               </Box>
//                             </TableCell>
//                             <TableCell>{assignment.assignedFrom}</TableCell>
//                             <TableCell>{formatDateTime(assignment.date)}</TableCell>
//                             <TableCell>
//                               <Chip
//                                 label={isCurrent ? 'Active' : 'Previous'}
//                                 color={isCurrent ? 'success' : 'default'}
//                                 size="small"
//                                 sx={{ borderRadius: 1 }}
//                               />
//                             </TableCell>
//                           </TableRow>
//                         );
//                       })}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 {/* Stats Cards */}
//                 <Grid container spacing={2} sx={{ mt: 3 }}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Zoom in={true} style={{ transitionDelay: '100ms' }}>
//                       <StatCard color={theme.palette.primary.main}>
//                         <Typography variant="h4" color="primary" fontWeight="bold">
//                           {totalAssignments}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Total Assignments
//                         </Typography>
//                       </StatCard>
//                     </Zoom>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Zoom in={true} style={{ transitionDelay: '200ms' }}>
//                       <StatCard color={theme.palette.info.main}>
//                         <Typography variant="h4" color="info.main" fontWeight="bold">
//                           {uniqueSales}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Unique Sales
//                         </Typography>
//                       </StatCard>
//                     </Zoom>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Zoom in={true} style={{ transitionDelay: '300ms' }}>
//                       <StatCard color={theme.palette.success.main}>
//                         <Typography variant="h6" color="success.main" fontWeight="bold" noWrap>
//                           {leadAssignmentHistory[0]?.salesName || 'N/A'}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Current Sales
//                         </Typography>
//                       </StatCard>
//                     </Zoom>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Zoom in={true} style={{ transitionDelay: '400ms' }}>
//                       <StatCard color={theme.palette.warning.main}>
//                         <Typography variant="h6" color="warning.main" fontWeight="bold" noWrap>
//                           {leadAssignmentHistory[leadAssignmentHistory.length - 1]?.salesName ||
//                             'N/A'}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           First Sales
//                         </Typography>
//                       </StatCard>
//                     </Zoom>
//                   </Grid>
//                 </Grid>
//               </>
//             ) : (
//               <Fade in={true}>
//                 <Box textAlign="center" py={5} color="text.secondary">
//                   <HistoryIcon sx={{ fontSize: 48, opacity: 0.5, mb: 2 }} />
//                   <Typography>No assignment history found</Typography>
//                 </Box>
//               </Fade>
//             )}
//           </InfoCard>
//         </Grow>

//         {/* Basic Information */}
//         <Slide direction="up" in={true} timeout={600}>
//           <InfoCard sx={{ mb: 4 }}>
//             <Box display="flex" alignItems="center" gap={1} mb={3}>
//               <PersonIcon color="primary" />
//               <Typography variant="h6" fontWeight="600">
//                 Basic Information
//               </Typography>
//             </Box>

//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), width: 32, height: 32 }}
//                   >
//                     <PersonIcon sx={{ fontSize: 18, color: 'primary.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Name
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {lead.name}
//                     </Typography>
//                   </Box>
//                 </InfoItem>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{ bgcolor: alpha(theme.palette.success.main, 0.1), width: 32, height: 32 }}
//                   >
//                     <PhoneIcon sx={{ fontSize: 18, color: 'success.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Phone
//                     </Typography>
//                     <Box display="flex" alignItems="center" gap={0.5}>
//                       <Typography variant="body1" fontWeight={500}>
//                         {lead.phone}
//                       </Typography>
//                       <Tooltip title="Copy number" arrow>
//                         <IconButton size="small" onClick={() => copyToClipboard(lead.phone)}>
//                           <CopyIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Open WhatsApp" arrow>
//                         <IconButton
//                           size="small"
//                           href={`https://wa.me/${lead.phone}`}
//                           target="_blank"
//                         >
//                           <WhatsAppIcon fontSize="small" color="success" />
//                         </IconButton>
//                       </Tooltip>
//                     </Box>
//                   </Box>
//                 </InfoItem>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{ bgcolor: alpha(theme.palette.info.main, 0.1), width: 32, height: 32 }}
//                   >
//                     <EmailIcon sx={{ fontSize: 18, color: 'info.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Email
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {lead.email || 'Not Exist'}
//                     </Typography>
//                   </Box>
//                 </InfoItem>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{ bgcolor: alpha(theme.palette.warning.main, 0.1), width: 32, height: 32 }}
//                   >
//                     <ProjectIcon sx={{ fontSize: 18, color: 'warning.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Project
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {lead.project}
//                     </Typography>
//                   </Box>
//                 </InfoItem>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{
//                       bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                       width: 32,
//                       height: 32,
//                     }}
//                   >
//                     <PersonIcon sx={{ fontSize: 18, color: 'secondary.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Developer
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {lead?.developer?.name}
//                     </Typography>
//                   </Box>
//                 </InfoItem>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <InfoItem>
//                   <Avatar
//                     sx={{ bgcolor: alpha(theme.palette.error.main, 0.1), width: 32, height: 32 }}
//                   >
//                     <CalendarIcon sx={{ fontSize: 18, color: 'error.main' }} />
//                   </Avatar>
//                   <Box flex={1}>
//                     <Typography variant="caption" color="text.secondary">
//                       Created At
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {moment(lead.createdAt).format('DD/MM/YYYY hh:mm A')}
//                     </Typography>
//                   </Box>
//                 </InfoItem>
//               </Grid>
//             </Grid>
//           </InfoCard>
//         </Slide>

//         {/* Lead With Sales Periods */}
//         {lead.salesAssignDurations?.length > 0 && (
//           <Fade in={true} timeout={800}>
//             <InfoCard sx={{ mb: 4 }}>
//               <Box display="flex" alignItems="center" gap={1} mb={3}>
//                 <ScheduleIcon color="primary" />
//                 <Typography variant="h6" fontWeight="600">
//                   Lead With Sales (Period)
//                 </Typography>
//               </Box>

//               <Grid container spacing={3}>
//                 {lead.salesAssignDurations.map((sales, idx) => (
//                   <Grid item xs={12} md={6} lg={4} key={idx}>
//                     <Zoom in={true} style={{ transitionDelay: `${idx * 100}ms` }}>
//                       <AnimatedCard
//                         elevation={3}
//                         sx={{
//                           borderRadius: 3,
//                           overflow: 'hidden',
//                           border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                         }}
//                       >
//                         <CardContent>
//                           <Box
//                             display="flex"
//                             justifyContent="space-between"
//                             alignItems="center"
//                             mb={2}
//                           >
//                             <Typography variant="h6" fontWeight="600">
//                               {sales.name}
//                             </Typography>
//                             <Chip
//                               label={`${sales.periods?.length || 0} Periods`}
//                               size="small"
//                               color="primary"
//                               sx={{ borderRadius: 2 }}
//                             />
//                           </Box>

//                           <Box display="flex" alignItems="center" gap={1} mb={2}>
//                             <ClockIcon fontSize="small" color="action" />
//                             <Typography variant="body2" color="text.secondary">
//                               Total: {sales.totalDuration}
//                             </Typography>
//                           </Box>

//                           <Divider sx={{ my: 2 }} />

//                           <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
//                             {sales.periods?.map((p, i) => (
//                               <Box
//                                 key={i}
//                                 sx={{
//                                   p: 1.5,
//                                   mb: 1,
//                                   borderRadius: 2,
//                                   bgcolor: alpha(theme.palette.primary.main, 0.04),
//                                   transition: 'all 0.2s',
//                                   border: `1px solid transparent`,
//                                   '&:hover': {
//                                     bgcolor: alpha(theme.palette.primary.main, 0.08),
//                                     borderColor: alpha(theme.palette.primary.main, 0.2),
//                                     transform: 'translateX(4px)',
//                                   },
//                                 }}
//                               >
//                                 <Typography
//                                   variant="caption"
//                                   display="block"
//                                   color="text.secondary"
//                                 >
//                                   From: <strong>{moment(p.from).format('DD/MM/YY hh:mm A')}</strong>
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   display="block"
//                                   color="text.secondary"
//                                 >
//                                   To: <strong>{moment(p.to).format('DD/MM/YY hh:mm A')}</strong>
//                                 </Typography>
//                                 <Box
//                                   display="flex"
//                                   justifyContent="space-between"
//                                   alignItems="center"
//                                   mt={1}
//                                 >
//                                   <Typography variant="caption" color="text.secondary">
//                                     Duration:
//                                   </Typography>
//                                   <Chip
//                                     label={p.durationStr}
//                                     size="small"
//                                     color="info"
//                                     sx={{ height: 20, fontSize: '0.625rem', borderRadius: 1 }}
//                                   />
//                                 </Box>
//                               </Box>
//                             ))}
//                           </Box>
//                         </CardContent>
//                       </AnimatedCard>
//                     </Zoom>
//                   </Grid>
//                 ))}
//               </Grid>
//             </InfoCard>
//           </Fade>
//         )}

//         {/* Stages Durations */}
//         {lead.salesDurations && (
//           <Fade in={true} timeout={1000}>
//             <InfoCard sx={{ mb: 4 }}>
//               <Box display="flex" alignItems="center" gap={1} mb={3}>
//                 <AssignmentIcon color="primary" />
//                 <Typography variant="h6" fontWeight="600">
//                   Stages Durations
//                 </Typography>
//               </Box>

//               {Object.entries(lead.salesDurations).map(([salesId, salesData], index) => (
//                 <Box key={salesId} sx={{ mb: 4 }}>
//                   <Slide
//                     direction="right"
//                     in={true}
//                     timeout={500}
//                     style={{ transitionDelay: `${index * 100}ms` }}
//                   >
//                     <Box>
//                       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                         <Box display="flex" alignItems="center" gap={1}>
//                           <Avatar
//                             sx={{ width: 32, height: 32, bgcolor: getAvatarColor(salesData.name) }}
//                           >
//                             {getInitials(salesData.name)}
//                           </Avatar>
//                           <Typography variant="subtitle1" fontWeight="600">
//                             {salesData.name}
//                           </Typography>
//                         </Box>
//                         <Chip
//                           label={`${salesData.interactions?.length || 0} stages`}
//                           size="small"
//                           sx={{ borderRadius: 2 }}
//                         />
//                       </Box>

//                       <TableContainer
//                         component={Paper}
//                         elevation={0}
//                         sx={{
//                           borderRadius: 2,
//                           border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                         }}
//                       >
//                         <Table size="small">
//                           <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.04) }}>
//                             <TableRow>
//                               <TableCell>Stage</TableCell>
//                               <TableCell>From</TableCell>
//                               <TableCell>To</TableCell>
//                               <TableCell>Duration</TableCell>
//                               <TableCell>Status</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {salesData.interactions.map((interaction, idx) => {
//                               const from = new Date(interaction.from);
//                               let to = new Date(interaction.to || new Date());
//                               let status =
//                                 idx === salesData.interactions.length - 1 ? 'Current' : 'Completed';

//                               return (
//                                 <TableRow
//                                   key={idx}
//                                   sx={{
//                                     bgcolor:
//                                       status === 'Current'
//                                         ? alpha(theme.palette.success.main, 0.04)
//                                         : 'inherit',
//                                     transition: 'background-color 0.3s',
//                                     '&:hover': {
//                                       bgcolor: alpha(theme.palette.primary.main, 0.02),
//                                     },
//                                   }}
//                                 >
//                                   <TableCell>
//                                     <Chip
//                                       label={interaction.stage}
//                                       size="small"
//                                       variant="outlined"
//                                       sx={{ borderRadius: 1, fontWeight: 500 }}
//                                     />
//                                   </TableCell>
//                                   <TableCell>{formatDateTime(from)}</TableCell>
//                                   <TableCell>{formatDateTime(to)}</TableCell>
//                                   <TableCell>
//                                     <Chip
//                                       label={formatDuration(to - from)}
//                                       size="small"
//                                       color={status === 'Current' ? 'success' : 'default'}
//                                       sx={{ fontWeight: 600, borderRadius: 1 }}
//                                     />
//                                   </TableCell>
//                                   <TableCell>
//                                     <Chip
//                                       label={status}
//                                       size="small"
//                                       color={
//                                         status === 'Current'
//                                           ? 'success'
//                                           : status === 'Completed'
//                                             ? 'info'
//                                             : 'default'
//                                       }
//                                       sx={{ borderRadius: 1 }}
//                                     />
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Box>
//                   </Slide>
//                 </Box>
//               ))}
//             </InfoCard>
//           </Fade>
//         )}

//         {/* Comments Section */}
//         {lead.comments?.length > 0 && (
//           <Fade in={true} timeout={1200}>
//             <InfoCard>
//               <Box display="flex" alignItems="center" gap={1} mb={3}>
//                 <CommentIcon color="primary" />
//                 <Typography variant="h6" fontWeight="600">
//                   Comments ({lead.comments.length})
//                 </Typography>
//               </Box>

//               <Box sx={{ maxHeight: 500, overflowY: 'auto', pr: 2 }}>
//                 {lead.comments.map((comment, index) => (
//                   <Fade
//                     in={true}
//                     timeout={500}
//                     style={{ transitionDelay: `${index * 100}ms` }}
//                     key={index}
//                   >
//                     <Box sx={{ mb: 4 }}>
//                       {/* First Comment */}
//                       <Box display="flex" gap={2}>
//                         <Avatar
//                           src={getCleanImageUrl(comment.sales.profileImg)}
//                           sx={{
//                             width: 48,
//                             height: 48,
//                             transition: 'transform 0.2s',
//                             '&:hover': { transform: 'scale(1.1)' },
//                           }}
//                         >
//                           {getInitials(comment.sales.name)}
//                         </Avatar>
//                         <Box flex={1}>
//                           <Box
//                             display="flex"
//                             justifyContent="space-between"
//                             alignItems="center"
//                             mb={1}
//                           >
//                             <Box display="flex" alignItems="center" gap={1}>
//                               <Typography variant="subtitle2" fontWeight="600">
//                                 {comment.sales.name}
//                               </Typography>
//                               <Chip
//                                 label="Comment"
//                                 size="small"
//                                 color="primary"
//                                 sx={{ height: 20, fontSize: '0.625rem', borderRadius: 1 }}
//                               />
//                             </Box>
//                             <Typography variant="caption" color="text.secondary">
//                               {moment(comment.firstcomment.date).format('DD/MM/YYYY hh:mm A')}
//                             </Typography>
//                           </Box>
//                           <CommentBubble isOwn={true}>
//                             <Typography variant="body2">{comment.firstcomment.text}</Typography>
//                           </CommentBubble>
//                         </Box>
//                       </Box>

//                       {/* Second Comment */}
//                       {comment.secondcomment && (
//                         <Box display="flex" gap={2} sx={{ mt: 2, ml: 6 }}>
//                           <Avatar
//                             src={getCleanImageUrl(comment.sales.profileImg)}
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               transition: 'transform 0.2s',
//                               '&:hover': { transform: 'scale(1.1)' },
//                             }}
//                           >
//                             {getInitials(comment.sales.name)}
//                           </Avatar>
//                           <Box flex={1}>
//                             <Box
//                               display="flex"
//                               justifyContent="space-between"
//                               alignItems="center"
//                               mb={1}
//                             >
//                               <Box display="flex" alignItems="center" gap={1}>
//                                 <Typography variant="subtitle2" fontWeight="600">
//                                   {comment.sales.name}
//                                 </Typography>
//                                 <Chip
//                                   label="Next Action"
//                                   size="small"
//                                   color="warning"
//                                   sx={{ height: 20, fontSize: '0.625rem', borderRadius: 1 }}
//                                 />
//                               </Box>
//                               <Typography variant="caption" color="text.secondary">
//                                 {moment(comment.secondcomment.date).format('DD/MM/YYYY hh:mm A')}
//                               </Typography>
//                             </Box>
//                             <CommentBubble isOwn={false}>
//                               <Typography variant="body2">{comment.secondcomment.text}</Typography>
//                             </CommentBubble>
//                           </Box>
//                         </Box>
//                       )}

//                       {/* Replies */}
//                       {comment.replies?.length > 0 && (
//                         <Box sx={{ ml: 8, mt: 2 }}>
//                           <Typography
//                             variant="caption"
//                             color="text.secondary"
//                             sx={{ display: 'block', mb: 1 }}
//                           >
//                             Replies ({comment.replies.length})
//                           </Typography>
//                           {comment.replies.map((reply, idx) => (
//                             <Fade
//                               in={true}
//                               timeout={300}
//                               style={{ transitionDelay: `${idx * 50}ms` }}
//                               key={idx}
//                             >
//                               <Box display="flex" gap={2} sx={{ mt: 2 }}>
//                                 <Avatar
//                                   src={getCleanImageUrl(reply?.user?.profileImg)}
//                                   sx={{
//                                     width: 32,
//                                     height: 32,
//                                     transition: 'transform 0.2s',
//                                     '&:hover': { transform: 'scale(1.1)' },
//                                   }}
//                                 >
//                                   {getInitials(reply?.user?.name)}
//                                 </Avatar>
//                                 <Box flex={1}>
//                                   <Box
//                                     display="flex"
//                                     justifyContent="space-between"
//                                     alignItems="center"
//                                     mb={1}
//                                   >
//                                     <Box display="flex" alignItems="center" gap={1}>
//                                       <Typography variant="caption" fontWeight="600">
//                                         {reply.user.name}
//                                       </Typography>
//                                       <ReplyIcon sx={{ fontSize: 12, color: 'text.secondary' }} />
//                                     </Box>
//                                     <Typography variant="caption" color="text.secondary">
//                                       {moment(reply.date).format('DD/MM/YYYY hh:mm A')}
//                                     </Typography>
//                                   </Box>
//                                   <Typography variant="body2" color="text.secondary">
//                                     {reply.text}
//                                   </Typography>
//                                 </Box>
//                               </Box>
//                             </Fade>
//                           ))}
//                         </Box>
//                       )}
//                       <Divider sx={{ my: 3 }} />
//                     </Box>
//                   </Fade>
//                 ))}
//               </Box>
//             </InfoCard>
//           </Fade>
//         )}
//       </ModalContainer>
//     </StyledModal>
//   );
// };



















// 20-5-2026
import React, { useEffect, useState } from 'react';
import {
  Modal, Box, Typography, Chip, CircularProgress,
  Avatar, IconButton, Tooltip,
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import {
  Phone as PhoneIcon,
  ContentCopy as CopyIcon,
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon,
  AccountTree as ProjectIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  AccessTime as ClockIcon,
  History as HistoryIcon,
  GetApp as DownloadIcon,
  Schedule as ScheduleIcon,
  Assignment as AssignmentIcon,
  Comment as CommentIcon,
  Close as CloseIcon,
  Business as BusinessIcon,
} from '@mui/icons-material';
import XLSX from '../utils/excelUtils';
import moment from 'moment';
import axios from 'axios';
import { db_url } from '../Api/BaseUrl';
import { useSelector, useDispatch } from 'react-redux';
import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';

const C = {
  accent:      '#0D47A1',
  accentSoft:  'rgba(13,71,161,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  border:      '#E8EAF0',
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.09)',
  warning:     '#F79009',
  warnSoft:    'rgba(247,144,9,0.09)',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  purple:      '#0D47A1',
  purpleSoft:  'rgba(124,58,237,0.08)',
  teal:        '#06B6D4',
  tealSoft:    'rgba(6,182,212,0.08)',
};

const getInitials = (name = '') =>
  (name || '').split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

const AVATAR_COLORS = [C.accent, '#10B981', '#F59E0B', '#EF4444', '#0D47A1', '#06B6D4', '#EC4899'];
const getAvatarColor = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
};

const fmt = (d) => d ? moment(d).format('DD/MM/YYYY hh:mm A') : '—';

const fmtDur = (ms) => {
  if (isNaN(ms) || ms < 0) return '—';
  const s = Math.floor(ms / 1000), m = Math.floor(s / 60), hr = Math.floor(m / 60), d = Math.floor(hr / 24);
  return [d > 0 && `${d}d`, hr % 24 > 0 && `${hr % 24}h`, m % 60 > 0 && `${m % 60}m`, s % 60 > 0 && `${s % 60}s`].filter(Boolean).join(' ') || '0s';
};

const Card = ({ children, sx = {} }) => (
  <Box sx={{ bgcolor: C.white, border: `1px solid ${C.border}`, borderRadius: '14px', p: '18px 20px', ...sx }}>
    {children}
  </Box>
);

const SecHead = ({ icon: Icon, label, badge, right, color = C.accent }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '14px' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ width: 30, height: 30, borderRadius: '8px', bgcolor: `${color}12`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon sx={{ fontSize: 15, color }} />
      </Box>
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.text, fontFamily: "'DM Sans',sans-serif" }}>{label}</Typography>
      {badge}
    </Box>
    {right}
  </Box>
);

const InfoCell = ({ icon: Icon, label, value, color = C.accent, extra }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, p: '10px 12px', borderRadius: '10px', '&:hover': { bgcolor: C.accentSoft }, transition: 'background 0.12s' }}>
    <Box sx={{ width: 28, height: 28, borderRadius: '7px', bgcolor: `${color}12`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '1px' }}>
      <Icon sx={{ fontSize: 14, color }} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 10, fontWeight: 600, color: C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans',sans-serif" }}>{label}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: '1px' }}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: C.text, fontFamily: "'DM Sans',sans-serif", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {value || '—'}
        </Typography>
        {extra}
      </Box>
    </Box>
  </Box>
);

const Badge2 = ({ label, color = C.accent, bg }) => (
  <Box sx={{ display: 'inline-flex', px: '8px', py: '2px', borderRadius: '20px', fontSize: 10, fontWeight: 700, color, bgcolor: bg || `${color}12`, fontFamily: "'DM Sans',sans-serif" }}>
    {label}
  </Box>
);

const TH_SX = { fontSize: 10, fontWeight: 700, color: C.textMuted, letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: `1px solid ${C.border}`, py: '9px', px: '12px', fontFamily: "'DM Sans',sans-serif", bgcolor: C.bg };
const TD_SX = { fontSize: 12, color: C.text, fontFamily: "'DM Sans',sans-serif", py: '9px', px: '12px', borderBottom: `1px solid ${C.border}` };

export const PreviewLeadModal = ({ show, onHide, lead, loading }) => {
  const dispatch = useDispatch();
  const [assignLoading, setAssignLoading] = useState(false);
  const [stagesLoading, setStagesLoading] = useState(false);
  const [stagesData,    setStagesData]    = useState([]);

  const resleadassigned   = useSelector(s => s.AllLead_Assigned.Lead_Assigned);
  const LeadAssignedarray = Array.isArray(resleadassigned?.data) ? resleadassigned.data : [];

  useEffect(() => {
    if (!show || !lead?.leadId) return;

    // assigned history
    setAssignLoading(true);
    dispatch(Get_All_Lead_Assigned_Data_Action(lead.leadId))
      .finally(() => setAssignLoading(false));

    // stages
    setStagesData([]);
    setStagesLoading(true);
    axios.post(`${db_url}api/v1/LeadAssigned/get-assigned-by-leads`, { leadIds: [lead.leadId] })
      .then(res => {
        console.log('✅ stages response:', JSON.stringify(res.data, null, 2));
        setStagesData(res.data?.data || []);
      })
      .catch(err => {
        console.log('❌ stages error:', err);
        setStagesData([]);
      })
      .finally(() => setStagesLoading(false));

  }, [show, lead?.leadId, dispatch]);

  const history = (() => {
    if (!Array.isArray(LeadAssignedarray) || !lead?.leadId) return [];
    return LeadAssignedarray
      .filter(a => (a.LeadId?._id || a.LeadId) === lead.leadId)
      .sort((a, b) => new Date(b.date_Assigned || b.createdAt) - new Date(a.date_Assigned || a.createdAt))
      .map((a, i) => ({ id: a._id || i, to: a.Assigned_to?.name || '—', from: a.Assigned_From?.name || '—', date: a.assignDateTime || a.createdAt }));
  })();

  const exportXls = () => {
    const ws = XLSX.utils.json_to_sheet(history.map(a => ({ 'Sales Name': a.to, 'From': a.from, 'Date': fmt(a.date) })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Assignments');
    XLSX.writeFile(wb, `assignments_${lead?.name || 'lead'}.xlsx`);
  };

  if (loading) return (
    <Modal open={show} onClose={onHide} sx={{ backdropFilter: 'blur(6px)' }}>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress sx={{ color: C.accent }} size={44} />
        <Typography sx={{ color: '#fff', fontFamily: "'DM Sans',sans-serif", fontSize: 13 }}>Loading…</Typography>
      </Box>
    </Modal>
  );

  if (!lead) return null;

  const totalStagesCount = stagesData.reduce((acc, s) =>
    acc + s.leads.reduce((a, l) => a + (l.stages?.length || 0), 0), 0
  );

  return (
    <Modal open={show} onClose={onHide} sx={{ backdropFilter: 'blur(8px)', backgroundColor: 'rgba(15,17,23,0.6)' }}>
      <Box sx={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        width: '94%', maxWidth: 1080, maxHeight: '90vh',
        overflowY: 'auto', overflowX: 'hidden',
        bgcolor: C.bg, borderRadius: '20px',
        boxShadow: '0 24px 64px rgba(16,24,40,0.22)',
        fontFamily: "'DM Sans',sans-serif",
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { width: 5 },
        '&::-webkit-scrollbar-thumb': { bgcolor: C.border, borderRadius: 99 },
      }}>

        {/* STICKY HEADER */}
        <Box sx={{
          position: 'sticky', top: 0, zIndex: 10,
          bgcolor: C.white, borderBottom: `1px solid ${C.border}`,
          px: '24px', py: '14px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Avatar sx={{ width: 36, height: 36, bgcolor: C.accentSoft, color: C.accent, fontSize: 13, fontWeight: 800 }}>
              {getInitials(lead.name)}
            </Avatar>
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 800, color: C.text, lineHeight: 1.2, letterSpacing: '-0.2px', fontFamily: "'DM Sans',sans-serif" }}>{lead.name}</Typography>
              <Typography sx={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>Lead Preview</Typography>
            </Box>
            {lead._id && (
              <Chip label={`ID: ${lead._id.slice(-6)}`} size="small"
                sx={{ fontSize: 10, fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, border: 'none' }} />
            )}
          </Box>
          <IconButton size="small" onClick={onHide}
            sx={{ color: C.textMuted, borderRadius: '8px', '&:hover': { color: C.danger, bgcolor: C.dangerSoft }, transition: 'all 0.15s' }}>
            <CloseIcon sx={{ fontSize: 17 }} />
          </IconButton>
        </Box>

        {/* BODY */}
        <Box sx={{ p: '18px 20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

          {/* ROW 1 */}
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            <Card>
              <SecHead icon={PersonIcon} label="Basic Information" />
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
                <InfoCell icon={PersonIcon}   label="Name"       value={lead.name}                          color={C.accent}  />
                <InfoCell icon={PhoneIcon}    label="Phone"      value={lead.phone}                         color={C.success}
                  extra={
                    <Box sx={{ display: 'flex' }}>
                      <Tooltip title="Copy"><IconButton size="small" onClick={() => navigator.clipboard.writeText(lead.phone)}><CopyIcon sx={{ fontSize: 11 }} /></IconButton></Tooltip>
                      <Tooltip title="WhatsApp"><IconButton size="small" href={`https://wa.me/${lead.phone}`} target="_blank"><WhatsAppIcon sx={{ fontSize: 11, color: '#25D366' }} /></IconButton></Tooltip>
                    </Box>
                  }
                />
                <InfoCell icon={EmailIcon}    label="Email"      value={lead.email || 'Not provided'}       color={C.teal}    />
                <InfoCell icon={ProjectIcon}  label="Project"    value={lead.project}                       color={C.warning} />
                <InfoCell icon={BusinessIcon} label="Developer"  value={lead?.developer?.name}              color={C.purple}  />
                <InfoCell icon={CalendarIcon} label="Created At" value={moment(lead.createdAt).format('DD/MM/YYYY hh:mm A')} color={C.danger} />
              </Box>
            </Card>

            <Card>
              <SecHead
                icon={HistoryIcon} label="Assignment History"
                badge={
                  assignLoading
                    ? <CircularProgress size={13} sx={{ color: C.accent, ml: 1 }} />
                    : <Chip label={history.length} size="small" sx={{ fontSize: 10, fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, border: 'none', height: 20, ml: 0.5 }} />
                }
                right={
                  history.length > 0 && (
                    <Tooltip title="Export Excel">
                      <IconButton size="small" onClick={exportXls}
                        sx={{ color: C.accent, bgcolor: C.accentSoft, borderRadius: '8px', '&:hover': { bgcolor: C.accent, color: '#fff' }, transition: 'all 0.15s' }}>
                        <DownloadIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )
                }
              />
              <Box sx={{ display: 'flex', gap: '10px', mb: '14px' }}>
                {[
                  { label: 'Total',   val: history.length,                                      color: C.accent  },
                  { label: 'Unique',  val: new Set(history.map(a => a.to)).size,                color: C.teal    },
                  { label: 'Current', val: history[0]?.to?.split(' ')[0] || '—',                color: C.success },
                  { label: 'First',   val: history[history.length - 1]?.to?.split(' ')[0] || '—', color: C.warning },
                ].map(({ label, val, color }) => (
                  <Box key={label} sx={{ flex: 1, textAlign: 'center', p: '10px 8px', borderRadius: '10px', border: `1px solid ${C.border}`, bgcolor: C.white }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 800, color, lineHeight: 1, fontFamily: "'DM Sans',sans-serif" }}>{val}</Typography>
                    <Typography sx={{ fontSize: 9, fontWeight: 600, color: C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans',sans-serif", mt: '3px' }}>{label}</Typography>
                  </Box>
                ))}
              </Box>
              {assignLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress size={22} sx={{ color: C.accent }} /></Box>
              ) : history.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <HistoryIcon sx={{ fontSize: 32, color: C.border, mb: 1 }} />
                  <Typography sx={{ fontSize: 12, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>No history yet</Typography>
                </Box>
              ) : (
                <Box sx={{ overflowX: 'auto', maxHeight: 210, overflowY: 'auto', borderRadius: '10px', border: `1px solid ${C.border}` }}>
                  <Table size="small" sx={{ tableLayout: 'fixed', minWidth: 400 }}>
                    <TableHead>
                      <TableRow>
                        {['Assigned To', 'Action Done By', 'Date'].map(h => (
                          <TableCell key={h} sx={TH_SX}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {history.map((a, i) => (
                        <TableRow key={a.id} sx={{ '&:hover': { bgcolor: C.accentSoft }, transition: 'background 0.1s' }}>
                          <TableCell sx={TD_SX}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                              <Avatar sx={{ width: 22, height: 22, bgcolor: getAvatarColor(a.to), fontSize: 9, fontWeight: 700 }}>{getInitials(a.to)}</Avatar>
                              <Typography sx={{ fontSize: 12, fontWeight: i === 0 ? 700 : 400, color: C.text, fontFamily: "'DM Sans',sans-serif" }}>{a.to}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ ...TD_SX, color: C.textMuted }}>{a.from}</TableCell>
                          <TableCell sx={{ ...TD_SX, color: C.textMuted, whiteSpace: 'nowrap', fontSize: 11 }}>{fmt(a.date)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              )}
            </Card>
          </Box>

          {/* ROW 2 */}
          {lead.salesAssignDurations?.length > 0 && (
            <Card>
              <SecHead icon={ScheduleIcon} label="Lead With Sales (Period)"
                badge={<Chip label={`${lead.salesAssignDurations.length} sales`} size="small" sx={{ fontSize: 10, fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, border: 'none', height: 20, ml: 0.5 }} />}
              />
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '12px' }}>
                {lead.salesAssignDurations.map((sales, idx) => (
                  <Box key={idx} sx={{ border: `1px solid ${C.border}`, borderRadius: '12px', overflow: 'hidden' }}>
                    <Box sx={{ px: '14px', py: '10px', bgcolor: C.accentSoft, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Avatar sx={{ width: 26, height: 26, bgcolor: getAvatarColor(sales.name), fontSize: 10, fontWeight: 700 }}>{getInitials(sales.name)}</Avatar>
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: C.text, fontFamily: "'DM Sans',sans-serif" }}>{sales.name}</Typography>
                      </Box>
                      <Chip label={`${sales.periods?.length || 0} periods`} size="small" sx={{ fontSize: 9, fontWeight: 600, bgcolor: C.accent, color: '#fff', border: 'none', height: 18 }} />
                    </Box>
                    <Box sx={{ px: '14px', py: '8px', display: 'flex', alignItems: 'center', gap: '6px', borderBottom: `1px solid ${C.border}` }}>
                      <ClockIcon sx={{ fontSize: 12, color: C.textMuted }} />
                      <Typography sx={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>Total: <strong style={{ color: C.text }}>{sales.totalDuration}</strong></Typography>
                    </Box>
                    <Box sx={{ px: '12px', py: '10px', display: 'flex', flexDirection: 'column', gap: '7px', maxHeight: 180, overflowY: 'auto' }}>
                      {sales.periods?.map((p, i) => (
                        <Box key={i} sx={{ p: '9px 12px', borderRadius: '8px', bgcolor: C.bg, border: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                          <Box>
                            <Typography sx={{ fontSize: 10, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>From: <strong style={{ color: C.text }}>{moment(p.from).format('DD/MM/YY hh:mm A')}</strong></Typography>
                            <Typography sx={{ fontSize: 10, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>To:&nbsp;&nbsp;&nbsp; <strong style={{ color: C.text }}>{moment(p.to).format('DD/MM/YY hh:mm A')}</strong></Typography>
                          </Box>
                          <Badge2 label={p.durationStr} color={C.teal} bg={C.tealSoft} />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Card>
          )}

          {/* ROW 3: Stages History */}
          <Card>
            <SecHead
              icon={AssignmentIcon}
              label="Stages History"
              badge={
                stagesLoading
                  ? <CircularProgress size={13} sx={{ color: C.accent, ml: 1 }} />
                  : <Chip label={`${totalStagesCount} stages`} size="small" sx={{ fontSize: 10, fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, border: 'none', height: 20, ml: 0.5 }} />
              }
            />

            {stagesLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress size={22} sx={{ color: C.accent }} />
              </Box>
            ) : totalStagesCount === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <AssignmentIcon sx={{ fontSize: 32, color: C.border, mb: 1 }} />
                <Typography sx={{ fontSize: 12, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>No stages yet</Typography>
              </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {stagesData.map((salesEntry) => {
                  const stages = salesEntry.leads?.flatMap(l => l.stages || []) || [];
                  if (!stages.length) return null;
                  return (
                    <Box key={salesEntry.salesId}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '10px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Avatar sx={{ width: 26, height: 26, bgcolor: getAvatarColor(salesEntry.salesName), fontSize: 10, fontWeight: 700 }}>
                            {getInitials(salesEntry.salesName)}
                          </Avatar>
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.text, fontFamily: "'DM Sans',sans-serif" }}>
                            {salesEntry.salesName}
                          </Typography>
                        </Box>
                        <Chip label={`${stages.length} stages`} size="small"
                          sx={{ fontSize: 10, fontWeight: 600, bgcolor: C.accentSoft, color: C.accent, border: 'none', height: 20 }} />
                      </Box>

                      <Box sx={{ borderRadius: '10px', border: `1px solid ${C.border}`, overflow: 'hidden' }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              {['#', 'Stage', 'Date', 'Selected At', 'Created At'].map(h => (
                                <TableCell key={h} sx={TH_SX}>{h}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {stages.map((stage, idx) => (
                              <TableRow key={stage.stageId || idx} sx={{ '&:hover': { bgcolor: C.accentSoft }, transition: 'background 0.1s' }}>
                                <TableCell sx={{ ...TD_SX, color: C.textMuted, width: 36 }}>{idx + 1}</TableCell>
                                <TableCell sx={TD_SX}>
                                  <Badge2
                                    label={stage.stageName || '—'}
                                    color={idx === stages.length - 1 ? C.success : C.accent}
                                    bg={idx === stages.length - 1 ? C.successSoft : C.accentSoft}
                                  />
                                </TableCell>
                                <TableCell sx={{ ...TD_SX, color: C.textMuted, fontSize: 11, whiteSpace: 'nowrap' }}>{fmt(stage.date)}</TableCell>
                                <TableCell sx={{ ...TD_SX, color: C.textMuted, fontSize: 11, whiteSpace: 'nowrap' }}>{fmt(stage.dateselectedforstage)}</TableCell>
                                <TableCell sx={{ ...TD_SX, color: C.textMuted, fontSize: 11, whiteSpace: 'nowrap' }}>{fmt(stage.createdAt)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            )}
          </Card>

          {/* ROW 4: Comments */}
          {lead.comments?.length > 0 && (
            <Card>
              <SecHead
                icon={CommentIcon} label="Comments"
                badge={<Chip label={lead.comments.length} size="small" sx={{ fontSize: 10, fontWeight: 700, bgcolor: C.purpleSoft, color: C.purple, border: 'none', height: 20, ml: 0.5 }} />}
                color={C.purple}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {lead.comments.map((comment, idx) => (
                  <Box key={idx}>
                    <Box sx={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                      <Avatar
                        src={comment.sales?.profileImg ? `${db_url}/UsersImages/${comment.sales.profileImg}` : null}
                        sx={{ width: 36, height: 36, bgcolor: getAvatarColor(comment.sales?.name || ''), fontSize: 12, fontWeight: 700, flexShrink: 0 }}
                      >
                        {getInitials(comment.sales?.name)}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box sx={{ bgcolor: C.bg, border: `1px solid ${C.border}`, borderRadius: '14px', p: '10px 14px' }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 700, color: C.text, fontFamily: "'DM Sans',sans-serif", mb: '4px' }}>
                            {comment.sales?.name}
                          </Typography>
                          <Typography sx={{ fontSize: 13, color: C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.6 }}>
                            {comment.firstcomment?.text}
                          </Typography>
                          {comment.secondcomment?.text && (
                            <Box sx={{ mt: '10px', p: '8px 12px', borderRadius: '9px', bgcolor: C.warnSoft, borderLeft: `3px solid ${C.warning}`, display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                              <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.warning, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: "'DM Sans',sans-serif", whiteSpace: 'nowrap', mt: '1px' }}>
                                Next Action
                              </Typography>
                              <Typography sx={{ fontSize: 12, color: C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.5 }}>
                                {comment.secondcomment.text}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', mt: '5px', pl: '4px' }}>
                          <Typography sx={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>
                            {moment(comment.firstcomment?.date).format('DD/MM/YYYY · hh:mm A')}
                          </Typography>
                          {comment.replies?.length > 0 && (
                            <>
                              <Box sx={{ width: 3, height: 3, borderRadius: '50%', bgcolor: C.border }} />
                              <Typography sx={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>
                                {comment.replies.length} {comment.replies.length === 1 ? 'Reply' : 'Replies'}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    {comment.replies?.length > 0 && (
                      <Box sx={{ ml: '46px', mt: '10px', position: 'relative' }}>
                        <Box sx={{ position: 'absolute', left: '-22px', top: 0, bottom: '16px', width: '2px', bgcolor: C.border, borderRadius: '2px' }} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          {comment.replies.map((reply, ri) => (
                            <Box key={ri} sx={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                              <Avatar
                                src={reply?.user?.profileImg ? `${db_url}/UsersImages/${reply.user.profileImg}` : null}
                                sx={{ width: 28, height: 28, bgcolor: getAvatarColor(reply?.user?.name || ''), fontSize: 10, fontWeight: 700, flexShrink: 0 }}
                              >
                                {getInitials(reply?.user?.name)}
                              </Avatar>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Box sx={{ bgcolor: C.bg, border: `1px solid ${C.border}`, borderRadius: '12px', p: '8px 12px' }}>
                                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: C.text, fontFamily: "'DM Sans',sans-serif", mb: '3px' }}>{reply?.user?.name}</Typography>
                                  <Typography sx={{ fontSize: 12, color: C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.5 }}>{reply.text}</Typography>
                                </Box>
                                <Typography sx={{ fontSize: 10, color: C.textMuted, fontFamily: "'DM Sans',sans-serif", mt: '4px', pl: '4px' }}>
                                  {moment(reply.date).format('DD/MM/YYYY · hh:mm A')}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Card>
          )}

        </Box>
      </Box>
    </Modal>
  );
};